<div class="logo-container" *ngIf="initialLoad">
	<img class="img" src="/assets/img/logo-adobesign.jpg" />
	<img class="text" src="/assets/img/logo-adobesign-text.jpg" />
</div>

<div class="loading-container" *ngIf="loading">
	<div class="lds-facebook">
		<div></div>
		<div></div>
		<div></div>
	</div>
</div>

<!-- TRIAL HEADER MESSAGE -->
<div *ngIf="!loading" class="trial-container" [ngClass]="{'out': contextService.signatureCount?.signatures && contextService.signatureCount.signatures.used >= contextService.signatureCount.signatures.total}">
	<div class="align-center">
		<i class="fas fa-sync-alt re-init-icon" (click)="reInit()"></i>
		<div class="flex-container">
			<div class="icon-container">
				<img src="/assets/img/logo-adobesign-white.jpg" />
			</div>
			<div class="message-container">
				<div class="super">ADOBE SIGN FOR PROCORE <ng-container *ngIf="contextService.clientDetailProcore.isTrial">TRIAL</ng-container></div>
				<div class="sub" *ngIf="contextService.signatureCount?.signatures">USED {{ contextService.signatureCount.signatures.used || 0 }} / {{ contextService.signatureCount.signatures.total || 0 }} SIGNATURES</div>
			</div>
		</div>
		<div class="signatures-message-container" *ngIf="contextService.signatureCount?.signatures && contextService.signatureCount.signatures.used >= contextService.signatureCount.signatures.total">
			<div>You are out of signatures.</div>
			<div>Contact support@shakeit.ai for additional signatures.</div>
		</div>
	</div>
</div>

<div class="form-container" [ngClass]="{'hidden': loading || showConfigure}">
	<form novalidate [formGroup]="form">
		<!-- STATUS HEADER MESSAGE -->
		<app-message *ngIf="signatures.length > 0 && !requestSent" [signatureObject]="signatures[0]" [expanded]="true" (emitRequestCancelled)="requestCancelled($event)"></app-message>
		<!-- <div class="view-previous" *ngIf="signatures.length > 1 && !showAllRequests && !requestSent"><a (click)="showAllRequests = true">View {{ signatures.length - 1 }} previous requests</a></div> -->
		<ng-container *ngIf="showAllRequests && !requestSent">
			<ng-container *ngFor="let signature of signatures; let i = index">
				<app-message *ngIf="i > 0" [signatureObject]="signature" [expanded]="false" (emitRequestCancelled)="requestCancelled($event)"></app-message>
			</ng-container>
		</ng-container>
		<!-- <div class="view-previous" *ngIf="signatures.length > 1 && showAllRequests && !requestSent"><a (click)="showAllRequests = false">Hide {{ signatures.length - 1 }} previous requests</a></div> -->
		<div class="group" *ngIf="!initialLoad && !requestSent && !errorResponse && (signatures.length == 0 || showCreateNewRequest)">
			<!-- FILE DRAG-AND-DROP -->
			<app-file (emitUploadedDoc)="setUploadedDoc($event)" (emitUseGeneratedFile)="setUseGeneratedFile($event)"></app-file>

			<!-- ATTACHMENTS -->
			<div class="group-container attachments" *ngIf="attachments.length > 0">
				<div class="message" (click)="showAttachmentsExpanded = !showAttachmentsExpanded">
					<em *ngIf="!showAttachmentsExpanded" class="fas fa-angle-down expand"></em>
					<em *ngIf="showAttachmentsExpanded" class="fas fa-angle-up expand"></em>
					<div class="group-title">Add Attachments</div>
				</div>
				<div class="data" [ngClass]="{'hidden': !showAttachmentsExpanded}">
					<!-- <div class="margin-ten" *ngIf="showAttachmentsExpanded"></div> -->
					<div class="filename-container" *ngFor="let attachment of attachments">
						<div class="switch-column">
							<div class="switch">
								<input [id]="'file_' + attachment.id" type="checkbox" class="switch-input client-checkbox" [(ngModel)]="attachment.checked" [ngModelOptions]="{standalone: true}">
								<label [for]="'file_' + attachment.id" class="switch-label">Switch</label>
							</div>
						</div>
						<div class="filename-column" title="{{ attachment.filename ? attachment.filename : attachment.name }}">{{ attachment.filename ? attachment.filename : attachment.name }}</div>
					</div>
				</div>
			</div>

			<!-- SIGNERS -->
			<div class="group-container" [ngClass]="{'warning': form.getRawValue()['signersList'].length > 0 && !form.get('signersList').valid, 'success': form.getRawValue()['signersList'].length > 0 && form.get('signersList').valid}">
				<div class="message" (click)="showSignersExpanded = !showSignersExpanded">
					<em *ngIf="!showSignersExpanded" class="fas fa-angle-down expand"></em>
					<em *ngIf="showSignersExpanded" class="fas fa-angle-up expand"></em>
					<div class="group-title">Add Signers</div>
				</div>
				<div class="data" *ngIf="showSignersExpanded">
					<button type="button" class="btn btn-primary btn-md add-external-email" (click)="addSigner('external', '')"><em class="fas fa-envelope"></em> Add External E-Mail</button>
					<button type="button" class="btn btn-primary btn-md add-procore-user" (click)="addSigner('internal', '')"><em class="fas fa-user"></em> Add Procore User</button>
					<ng-container formArrayName="signersList">
						<ng-container *ngFor="let signer of form.getRawValue()['signersList']; trackBy: trackSigners; let i = index">
							<ng-container [formGroupName]="i">
								<div class="signer-container" [ngClass]="signer.signerType">
									<div class="number-container">
										<div class="first"><em *ngIf="form.getRawValue()['signersList'].length > 1 && i !== 0" class="fas fa-chevron-up" (click)="moveSignerUp(i)" title="Move Up"></em></div>
										<div class="middle">
											<div class="number">{{ i + 1 }}</div>
										</div>
										<div class="last"><em *ngIf="form.getRawValue()['signersList'].length > 1 && i !== form.getRawValue()['signersList'].length - 1" class="fas fa-chevron-down" (click)="moveSignerDown(i)" title="Move Down"></em></div>
									</div>
									<div class="field-container">
										<ng-container *ngIf="signer.signerType === 'internal'">
											<div class="form-row">
												<!-- <label for="internalSignerEmail">Signer{{ signer.signerType === 'internal' ? '*' : '' }}</label> -->
												<ng-select placeholder="Select a person" [items]="internalUsers" formControlName="signerEmail" id="internalSignerEmail" bindLabel="name" bindValue="email" [clearable]="false" (change)="updateInternalSigner($event, i)"></ng-select>
												<!-- <div *ngFor="let user of internalUsers">{{ user.name }}</div> -->
											</div>
										</ng-container>
										<ng-container *ngIf="signer.signerType === 'external'">

											<!-- <label for="signerName">Signer Name*</label> -->
											<input type="text" placeholder="Signer name" formControlName="signerName" id="signerName" class="form-control">

											<!-- <label for="signerEmail">Signer E-mail*<span *ngIf="selectedTemplate"> ({{ signer.role }})</span></label> -->
											<input type="text" placeholder="Signer e-mail" formControlName="signerEmail" id="signerEmail" class="form-control">

										</ng-container>
										<button type="button" class="btn btn-primary btn-md btn-remove" (click)="removeSigner(i)">Remove Signer</button>
									</div>
								</div>
							</ng-container>
						</ng-container>
					</ng-container>
				</div>
			</div>

			<!-- OPTIONS -->
			<!-- <div class="options-container" *ngIf="originalProcoreInfo.enableDropboxSignTemplates && templates.length > 0">
				<div class="switch-row">
					<label>Dropbox Sign Template</label>
					<select class="template-dropdown" id="selectedTemplate" [(ngModel)]="selectedTemplate" [ngModelOptions]="{standalone: true}" [disabled]="uploadedDoc || useGeneratedFile" (change)="templateSelected($event)">
						<option value=""></option>
						<option *ngFor="let template of templates" [value]="template.template_id">{{ template.title }}</option>
					</select>
				</div>
			</div> -->
			<!-- <div class="attachment-container" *ngIf="attachments.length > 0">
				<div class="group-title">Add Attachments</div>
				<div class="switch-row" *ngFor="let attachment of attachments">
					<label [for]="'file_' + attachment.id" class="input-label">{{ attachment.filename ? attachment.filename : attachment.name }}</label>
					<div class="switch">
						<input [id]="'file_' + attachment.id" type="checkbox" class="switch-input client-checkbox" [(ngModel)]="attachment.checked" [ngModelOptions]="{standalone: true}">
						<label [for]="'file_' + attachment.id" class="switch-label">Switch</label>
					</div>
				</div>
			</div> -->
			<!-- <div class="options-container" *ngIf="originalProcoreInfo.allowDeclineRequest || originalProcoreInfo.allowSignerReassignment || originalProcoreInfo.allowExpirationDate">
				<div class="group-title">Request Options</div>
				<div class="switch-row" *ngIf="originalProcoreInfo.allowDeclineRequest">
					<label>Allow the signer to decline the request</label>
					<div class="switch">
						<input id="allowDecline" formControlName="allowDecline" type="checkbox" class="switch-input client-checkbox">
						<label for="allowDecline" class="switch-label">Switch</label>
					</div>
				</div>
				<div class="switch-row" *ngIf="originalProcoreInfo.allowSignerReassignment">
					<label>Allow the signer to re-assign the request</label>
					<div class="switch">
						<input id="allowReassign" formControlName="allowReassign" type="checkbox" class="switch-input client-checkbox">
						<label for="allowReassign" class="switch-label">Switch</label>
					</div>
				</div>
				<div class="switch-row" *ngIf="originalProcoreInfo.allowExpirationDate">
					<label>Expiration Date</label>
					<div>
						<input type="date" [min]="getExpirationMinDate()" [max]="getExpirationMaxDate()" formControlName="expirationDate" id="expirationDate" class="form-control">
					</div>
				</div>
			</div> -->

			<!-- ADDITIONAL OPTIONS -->
			<div class="group-container" *ngIf="contextService.clientDetailProcore.allowExpirationDate || projectConfigs.allowDefaultLocationOverride">
				<div class="message" (click)="showOptionsExpanded = !showOptionsExpanded">
					<em *ngIf="!showOptionsExpanded" class="fas fa-angle-down expand"></em>
					<em *ngIf="showOptionsExpanded" class="fas fa-angle-up expand"></em>
					<div class="group-title">Additional Options</div>
				</div>
				<div class="data" [ngClass]="{'hidden': !showOptionsExpanded}">
					<div class="switch-row" *ngIf="contextService.clientDetailProcore.allowExpirationDate">
						<label>Expiration Date</label>
						<div>
							<input type="date" [min]="getExpirationMinDate()" [max]="getExpirationMaxDate()" formControlName="expirationDate" id="expirationDate" class="form-control">
						</div>
					</div>
					<div class="switch-row" *ngIf="projectConfigs.allowDefaultLocationOverride">
						<div class="margin-ten"></div>
						<label for="fileLocation">Set Executed File Storage Location</label>
						<select class="template-dropdown no-margin" id="fileLocation" formControlName="fileLocation">
							<option value="default">{{ getDefaultFileLocationLabel() }}</option>
							<option *ngFor="let folderOption of folderOptions" [value]="folderOption.id">{{ folderOption.name }}</option>
						</select>
					</div>
				</div>
			</div>
		</div>

		<!-- <ng-container *ngIf="isSubmittal">
			<div class="group" *ngIf="!loading && !signature && !isSubmittalManager">
				<div class="message"><em class="fas fa-info-circle"></em> The signature request must be made by the Submittal Manager</div>
			</div>
			<div class="group" *ngIf="!loading && signature && !isSigner">
				<div class="message"><em class="fas fa-info-circle"></em> Your signature is not required for this Submittal</div>
			</div>
			<div class="group" *ngIf="!loading && signature && isSigner && !hasBallInCourt">
				<div class="message"><em class="fas fa-info-circle"></em> It is not your turn to sign the Submittal</div>
			</div>
		</ng-container>
		<ng-container *ngIf="isRfi">
			<div class="group" *ngIf="!loading && !signature && !isRfiManager">
				<div class="message"><em class="fas fa-info-circle"></em> The signature request must be made by the RFI Manager</div>
			</div>
		</ng-container> -->

		<div class="error-container" *ngIf="errorResponse">
			<div class="error-title" [innerHTML]="errorResponse"></div>
			<div class="error-back"><a (click)="errorResponse = ''">Back</a></div>
		</div>

		<!-- Remove this eventually -->
		<!-- <button *ngIf="!signature" type="button" class="btn btn-primary btn-md launch-sign" (click)="submit()"><em class="fas fa-signature"></em> Launch Adobe Acrobat Sign</button> -->

		<ng-container *ngIf="!initialLoad && !requestSent && !errorResponse">
			<button *ngIf="contextService.procoreUserInfo.isAdmin" class="btn btn-primary btn-md btn-configure" (click)="showConfigureForm()"><i class="fas fa-cog"></i></button>
			<div class="btn-launch-container">
				<ng-container *ngIf="!isSubmittal">
					<button *ngIf="signatures.length > 1 && !showAllRequests && !showCreateNewRequest" type="button" class="btn btn-primary btn-md new-request" (click)="showAllRequests = true">View {{ signatures.length - 1 }} Previous Requests</button>
					<button *ngIf="signatures.length > 1 && showAllRequests" type="button" class="btn btn-primary btn-md" (click)="showAllRequests = false">Hide {{ signatures.length - 1 }} Previous Requests</button>
					<button *ngIf="signatures.length > 0 && !showCreateNewRequest && !showAllRequests" type="button" class="btn btn-primary btn-md" (click)="showCreateNewRequest = true">Create New Request</button>
					<button *ngIf="signatures.length > 0 && showCreateNewRequest" type="button" class="btn btn-primary btn-md" (click)="showCreateNewRequest = false">Cancel New Request</button>
					<button *ngIf="signatures.length == 0" type="button" class="btn btn-primary btn-md launch-sign" [disabled]="loadingGeneratedFile || !form.valid || (!uploadedDoc && !useGeneratedFile) || form.getRawValue()['signersList'].length == 0 || (contextService.signatureCount?.signatures && contextService.signatureCount.signatures.used >= contextService.signatureCount.signatures.total)" (click)="submit()"><em class="fas fa-signature"></em> Launch Adobe Acrobat Sign</button>
					<!-- 
					<button *ngIf="signature && !signatureRequestExpired && signature.status !== 'CANCELLED' && signature.status !== 'COMPLETED' && (!isRfi || isRfiManager) && !showForm" type="button" class="btn btn-primary btn-md cancel-request" (click)="cancel()">Cancel Request</button>
					<button *ngIf="signature && signature.status !== 'CANCELLED' && signature.status !== 'COMPLETED' && (!isRfi || isRfiManager) && showForm" type="button" class="btn btn-primary btn-md cancel-edit-request" (click)="showForm = false">Cancel Edit Request</button>
					<button *ngIf="signature && !showForm && (!isRfi || isRfiManager)" type="button" class="btn btn-primary btn-md" (click)="showForm = true" [ngClass]="{'create-new-request': signature.status === 'COMPLETED' || signatureRequestExpired, 'edit-request': signature.status !== 'COMPLETED' && !signatureRequestExpired }">{{ signature.status === 'COMPLETED' || signatureRequestExpired ? 'Create New Request' : 'Edit Request' }}</button>
					<button *ngIf="signature && !signatureRequestExpired && !showForm && (!isRfi || isRfiManager) && signature.status === 'REQUESTED'" type="button" class="btn btn-primary btn-md send-reminder" (click)="sendReminder()">Send Reminder</button>
					<button *ngIf="signature && signature.status !== 'COMPLETED' && signature.status !== 'CANCELLED' && showForm && (!isRfi || isRfiManager)" type="button" class="btn btn-primary btn-md resend-request" [disabled]="loadingGeneratedFile || !form.valid || (!uploadedDoc && !useGeneratedFile) || form.getRawValue()['signersList'].length === 0" (click)="cancelAndResend()"><em class="fas fa-signature"></em> Launch Adobe Acrobat Sign</button>
					<button *ngIf="signature && signature.status === 'CANCELLED' && showForm && (!isRfi || isRfiManager)" type="button" class="btn btn-primary btn-md send-new-request wide" [disabled]="loadingGeneratedFile || !form.valid || (!uploadedDoc && !useGeneratedFile) || form.getRawValue()['signersList'].length === 0" (click)="submit()"><em class="fas fa-signature"></em> Launch Adobe Acrobat Sign</button>
					<button *ngIf="signature && signature.status === 'COMPLETED' && showForm && (!isRfi || isRfiManager)" type="button" class="btn btn-primary btn-md cancel-new-request" (click)="showForm = false">Cancel New Request</button>
					<button *ngIf="signature && signature.status === 'COMPLETED' && showForm && (!isRfi || isRfiManager)" type="button" class="btn btn-primary btn-md send-new-request right" [disabled]="loadingGeneratedFile || !form.valid || (!uploadedDoc && !useGeneratedFile) || form.getRawValue()['signersList'].length === 0" (click)="submit()"><em class="fas fa-signature"></em> Launch Adobe Acrobat Sign</button> 
					-->
				</ng-container>
				<!-- 
				<ng-container *ngIf="isSubmittal">
					<button *ngIf="isSubmittalManager && (!signature || (signature && signature.status === 'COMPLETED' && showForm))" type="button" class="btn btn-primary btn-md" [disabled]="loadingGeneratedFile || !form.valid || (!uploadedDoc && !useGeneratedFile) || form.getRawValue()['signersList'].length === 0" (click)="submitSignatureRequest()"><em class="fas fa-signature"></em> Send to Adobe Acrobat Sign</button>
					<button *ngIf="hasBallInCourt" type="button" class="btn btn-primary btn-md" (click)="signSignatureRequest()">Sign Request</button>
				</ng-container> 
				-->
			</div>
			<button *ngIf="showCreateNewRequest && signatures.length > 0" type="button" class="btn btn-primary btn-md launch-sign" [disabled]="loadingGeneratedFile || !form.valid || (!uploadedDoc && !useGeneratedFile) || form.getRawValue()['signersList'].length == 0 || (contextService.signatureCount?.signatures && contextService.signatureCount.signatures.used >= contextService.signatureCount.signatures.total)" (click)="submit()"><em class="fas fa-signature"></em> Launch Adobe Acrobat Sign</button>
		</ng-container>

		<div *ngIf="reminderMessage" class="reminder-container">
			{{ reminderMessage }}
			<br /><button type="button" class="btn btn-primary btn-md" (click)="reminderMessage = ''">Close</button>
		</div>

		<ng-container *ngIf="signatures.length > 0 && reminders.length > 0 && !requestSent">
			<div class="previous-link-container"><a (click)="showReminders = !showReminders">{{ showReminders ? 'Hide Reminder History' : 'View Reminder History'}}</a></div>
			<div class="previous-data-container" *ngIf="showReminders">
				<ng-container *ngFor="let reminder of reminders">
					<div class="group">
						<div class="request-data">
							<div class="left">Sent</div>
							<div class="right">{{ reminder.dateSent | date:'MMM d, y' }}</div>
						</div>
						<div class="request-data">
							<div class="left">Recipient</div>
							<div class="right">{{ reminder.signerEmail }}</div>
						</div>
					</div>
				</ng-container>
			</div>
		</ng-container>

		<div *ngIf="requestSent && !isSubmittal && !isRfi" class="launched-message">
			<div>Adobe Sign has been launched. Wait a few seconds to reload this panel after the signature request has been sent.</div>
			<div class="reinit-container"><i class="fas fa-sync-alt" (click)="reInit()"></i></div>
		</div>
		<div *ngIf="requestSent && (isSubmittal || isRfi)">
			The signature request has been created. You may reload this panel to track its status.
		</div>
		<div *ngIf="authError">
			Your browser is potentially blocking popups. Please turn off any popup blockers and refresh the page.
		</div>
	</form>
</div>

<app-configure *ngIf="showConfigure" (emitExit)="exitConfiguration()" [folders]="folders"></app-configure>